import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const VipPointsTurnoverStyle = {
  wrapper: css`
    position: relative;
    width: 100%;
  `,
  title: css`
    font-size: 22px;
    font-weight: 600;
    margin-top: 40px;
  `,
  vipPoint: css`
    display: flex;
    align-items: stretch;
    gap: 16px;
    margin-top: 20px;

    ${media.md} {
      flex-direction: column-reverse;
    }

    .wrap-item {
      padding: 15px;
      border-radius: 10px;
      background: ${theme.colors.primary[650]};
      display: inline-flex;
      flex-flow: row wrap;
      justify-content: center;
      text-align: center;

      ${media.md} {
        padding: 25px 15px;
      }

      &.left-box {
        flex: 2;
      }

      &.right-box {
        flex: 1;
        flex-direction: column;
        align-items: flex-start;
      }
      .vip-points {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          display: flex;
          margin-right: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
        }

        p {
          color: ${theme.colors.secondary[900]};
          font-size: 30px;
          font-family: fantasy;
          line-height: 40px;
        }
      }
    }

    .form-control {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      width: 100%;
      margin-bottom: 10px;

      ${media.md} {
        flex-direction: column;
      }

      .form-input {
        width: 100%;
      }

      input {
        position: relative;
        font-size: 16px;
        height: 40px;
        width: 100%;
        color: #fff;
        display: block;
        outline: none;
        padding: 11px;
        border: 1px solid #68686880;
        border-radius: 3px;
        background: rgba(51, 51, 51, 0.3);

        &::placeholder {
          font-size: 14px;
        }

        &:focus {
          border-color: #ffdf18;
          outline: none;
        }
      }

      button {
        border-radius: 20px;
        background: #ffb31a;
        width: 134px;
        height: 40px;
        transition: all 0.2s ease;
        border: none;
        outline: none;

        ${media.md} {
          width: 100%;
          margin-top: 10px;
        }
        span {
          color: #000;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
        }

        &:hover {
          background: #ffb31a !important;
          transform: scale(1.05);
        }

        &.disabled,
        &:disabled {
          opacity: 0.5;
          pointer-events: none;
        }
      }
    }

    .rate {
      margin-top: 10px;
      font-size: 12px;
      font-style: italic;
      padding: 0 10px;
      width: 100%;
      color: #ffffff;
      text-align: left;

      &.title {
        font-style: normal;
        font-weight: bold;
        color: #f5a303;
      }

      &.error .warning {
        color: red;
        margin-left: 10px;
      }
    }
  `
};
